/* Lupa da página de produto — Sul Etiquetas (ago/2026)
   Clique na foto abre a imagem grande em tela cheia. Dentro do visualizador:
   novo clique amplia (2x) e segue o mouse, setas trocam de foto, Esc fecha. */
(function () {
  'use strict';

  var overlay, imgEl, contadorEl, fotos = [], indice = 0, ampliada = false;

  function maiorResolucao(src) {
    // tira o sufixo de tamanho do CDN (_800x) para pegar a imagem original
    return src.replace(/_(\d+)x(\d+)?(_crop_[a-z]+)?\.(jpe?g|png|webp|gif)/i, '.$4');
  }

  function montar() {
    overlay = document.createElement('div');
    overlay.className = 'zoom-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Foto ampliada do produto');
    overlay.innerHTML =
      '<div class="zoom-overlay__palco">' +
      '<img class="zoom-overlay__img" alt="">' +
      '<button type="button" class="zoom-overlay__fechar" aria-label="Fechar">&times;</button>' +
      '<button type="button" class="zoom-overlay__nav zoom-overlay__nav--prev" aria-label="Foto anterior">&#8249;</button>' +
      '<button type="button" class="zoom-overlay__nav zoom-overlay__nav--next" aria-label="Próxima foto">&#8250;</button>' +
      '<span class="zoom-overlay__contador"></span>' +
      '</div>';
    document.body.appendChild(overlay);

    imgEl = overlay.querySelector('.zoom-overlay__img');
    contadorEl = overlay.querySelector('.zoom-overlay__contador');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('zoom-overlay__palco')) fechar();
    });
    overlay.querySelector('.zoom-overlay__fechar').addEventListener('click', fechar);
    overlay.querySelector('.zoom-overlay__nav--prev').addEventListener('click', function () { trocar(-1); });
    overlay.querySelector('.zoom-overlay__nav--next').addEventListener('click', function () { trocar(1); });

    imgEl.addEventListener('click', function (e) {
      ampliada = !ampliada;
      imgEl.classList.toggle('is-ampliada', ampliada);
      if (!ampliada) imgEl.style.transformOrigin = 'center center';
      e.stopPropagation();
    });

    imgEl.addEventListener('mousemove', function (e) {
      if (!ampliada) return;
      var r = imgEl.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      imgEl.style.transformOrigin = x + '% ' + y + '%';
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') fechar();
      if (e.key === 'ArrowLeft') trocar(-1);
      if (e.key === 'ArrowRight') trocar(1);
    });
  }

  function pintar() {
    var f = fotos[indice];
    if (!f) return;
    imgEl.src = f.src;
    imgEl.alt = f.alt || '';
    ampliada = false;
    imgEl.classList.remove('is-ampliada');
    imgEl.style.transformOrigin = 'center center';
    contadorEl.textContent = (indice + 1) + ' / ' + fotos.length;
    var mostrarNav = fotos.length > 1;
    overlay.querySelector('.zoom-overlay__nav--prev').style.display = mostrarNav ? '' : 'none';
    overlay.querySelector('.zoom-overlay__nav--next').style.display = mostrarNav ? '' : 'none';
    contadorEl.style.display = mostrarNav ? '' : 'none';
  }

  function trocar(passo) {
    indice = (indice + passo + fotos.length) % fotos.length;
    pintar();
  }

  function abrir(i) {
    indice = i;
    pintar();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function fechar() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function init() {
    var itens = document.querySelectorAll('.product__media-item img');
    if (!itens.length) return;
    if (!overlay) montar();

    fotos = [];
    itens.forEach(function (img, i) {
      fotos.push({ src: maiorResolucao(img.currentSrc || img.src), alt: img.alt });
      if (img.dataset.zoomReady === '1') return;
      img.dataset.zoomReady = '1';
      img.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        abrir(i);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
